import { render, staticRenderFns } from "./GlobalSearchInput.vue?vue&type=template&id=e401dfa4&"
import script from "./GlobalSearchInput.vue?vue&type=script&lang=ts&"
export * from "./GlobalSearchInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports